import { render, staticRenderFns } from "./MoveReplacementCandidate.html?vue&type=template&id=6d47a653&external"
import script from "./MoveReplacementCandidate.ts?vue&type=script&lang=ts&external"
export * from "./MoveReplacementCandidate.ts?vue&type=script&lang=ts&external"
import style0 from "./MoveReplacementCandidate.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports